import React from 'react';
import { useNavigate } from 'react-router-dom';
import useThumbnailUrl from '../../hooks/useThumbnailUrl';
import useGetBeatInfo from '../../hooks/useGetBeatInfo';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { otpModalState } from '../../recoil/otp/otpModalAtom';
import ERROR_CODES from '../../constants/errorCodes';
import * as Sentry from '@sentry/react';
import { countryState } from '../../recoil/country/countryAtom';
import useCheckTokenExpiry from '../../hooks/useCheckTokenExpiry';

const DetailCarouselCard = ({ item }) => {
  const navigate = useNavigate();
  const imageUrl = useThumbnailUrl(item.clip_thumbnail_info, 384);
  const accessToken = localStorage.getItem('access_token');
  const setOtpLogin = useSetRecoilState(otpModalState);
  const countryData = useRecoilValue(countryState);
  const exp = localStorage.getItem('exp');

  // 단순 로그인 확인용
  const { error, isLogin, hasAccessToken } = useGetBeatInfo(accessToken, countryData?.country);
  const isAccessTokenExpired = useCheckTokenExpiry(exp);

  const clearSession = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('exp');
    Sentry.setUser(null);
  };

  // 단순 로그인 확인용
  const handleLoginCheck = () => {
    const errorCode = error?.response && error?.response.data && error?.response.data.code;
    if (!hasAccessToken) {
      clearSession();
      setOtpLogin(true);
      return false;
    }

    if (isAccessTokenExpired) {
      clearSession();
      setOtpLogin(true);
      return false;
    }

    if (!isLogin) {
      clearSession();
      setOtpLogin(true);
      return false;
    }

    if (
      errorCode === ERROR_CODES.invalidToken ||
      errorCode === ERROR_CODES.tokenExpired ||
      errorCode === ERROR_CODES.unauthorized
    ) {
      clearSession();
      setOtpLogin(true);
      return false;
    }

    return true;
  };

  const moveLiveClipPage = (clipmetaid, live_clip_id) => {
    if (handleLoginCheck()) navigate(`/video-live-detail/${clipmetaid}?clip_live_id=${live_clip_id}`);
  };

  const moveClipPage = (clipmetaid) => {
    if (handleLoginCheck()) navigate(`/video-clip-detail/${clipmetaid}`);
  };

  const movePage = () => {
    // 라이브 클립
    if (item.clip_type === 'live' && item.live_clip_id) {
      moveLiveClipPage(item.clipmetaid, item.live_clip_id);
    } else {
      moveClipPage(item.clipmetaid);
    }
  };

  return (
    <div className={'detail-carousel-card'}>
      <figure className='detail-carousel-img-group cursor-pointer' onClick={movePage}>
        <img
          src={imageUrl || '/images/img_no_img.png'}
          alt='video image'
          className={'detail-carousel-img'}
          width='381'
          height='214'
          onError={(e) => {
            e.target.onerror = null; // onError 이미지도 실패했을 때 무한루프 방지
            e.target.src = '/images/img_no_img.png';
          }}
          decoding={'async'}
        />
      </figure>
      <div className='detail-carousel-txt-group'>
        <h3 className={'detail-carousel-txt-title cursor-pointer'} onClick={movePage}>
          {item.clip_name}
        </h3>
      </div>
    </div>
  );
};

export default DetailCarouselCard;
